import { ProjectType } from 'appTypes';

export default function getPracticeTaskingUrl(
  id: number,
  topicId: number,
  lessonId: number
) {
  return `/learning/${topicId}/lesson/${lessonId}/practice/${ProjectType.IMAGE_ANNOTATION}/${id}`;
}
